import React, { useState, useEffect } from 'react';
import { Typography, Box, Button } from '@mui/material';
import useStyles from './styles';
import { fetchLogsFromApi } from '../../../api/index.js';


const LogsView = () => {
  const classes = useStyles();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const { data } = await fetchLogsFromApi();
      setLogs(data);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div className={classes.container}>
      <Typography variant="h5" className={classes.header}>
        Logs de synchronisation
      </Typography>
      <Typography className={classes.header}>- Affichage des 1000 derniers logs -</Typography>
      <Button variant="contained" color="primary" onClick={fetchLogs} disabled={loading}>
        {loading ? 'Actualisation...' : 'Actualiser'}
      </Button>
      {logs.length > 0 ? (
        <ul className={classes.list}>
          {logs.map((log, index) => (
            <li key={index} className={classes.listItem}>
              <Box>
                <Typography variant="body1"><strong>Service:</strong> {log.serviceName}</Typography>
                <Typography variant="body1"><strong>Date:</strong> {new Date(log.timestamp).toLocaleString()}</Typography>
                <Typography variant="body1"><strong>Code:</strong> {log.code}</Typography>
                <Typography variant="body1"><strong>Info:</strong> {log.info}</Typography>
                {log.stacktrace && (
                  <Typography
                    variant="body2"
                    color={log.code !== '200' && log.code !== '202' ? 'error' : '#0a76b9'}
                  >
                    <strong>{log.code !== '200' && log.code !== '202' ? 'Erreur:' : 'Détail:'}</strong> {log.stacktrace}
                  </Typography>
                )}
              </Box>
            </li>
          ))}
        </ul>
      ) : (
        <Typography>Aucun log disponible</Typography>
      )}
    </div>
  );
};

export default LogsView;